import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Suppress extension-related frame_ant.js errors in development overlay
if (process.env.NODE_ENV === 'development') {
  const isExtensionError = (stack, filename) => {
    const s = String(stack || '');
    const f = String(filename || '');
    return (
      s.includes('frame_ant') || 
      s.includes('chrome-extension://') || 
      f.includes('frame_ant') || 
      f.includes('chrome-extension://')
    );
  };

  window.addEventListener('unhandledrejection', (event) => {
    const stack = event.reason?.stack || '';
    if (isExtensionError(stack, '')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  window.addEventListener('error', (event) => {
    const stack = event.error?.stack || '';
    const filename = event.filename || '';
    if (isExtensionError(stack, filename)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
